import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class Service {
    public app: any = null;
    public inited = false;

    public async init(app?: any) {
        if (app) this.app = app;
        this.inited = true;
        await this.render();
        return this;
    }

    public async render() {
        this.app?.ref?.detectChanges();
    }
}

export default Service;
